<div class="permission-card">
  <div class="permission-title">
    <span class="title-checkbox">
      <svg viewBox="0 0 24 24" fill="none" class="h-4 w-4">
        <path d="M6 12.5L10 16.5L18 8.5" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </span>
    <h3>{{action || "Select Permmissions"}}</h3>
  </div>

  <div class="table-wrap">
    <table class="permission-table">
      <thead>
        <tr>
          <th class="module-col">Module</th>
          <th>View</th>
          <th>Create</th>
          <th>Edit</th>
          <th>Approve</th>
          <th>Delete</th>
          <th>All</th>
        </tr>
      </thead>

      <tbody>
        <tr *ngFor="let row of rows; let i = index; trackBy: trackByModule">
          <td class="module-name">{{ row.module }}</td>

          <td *ngFor="let col of columns">
            <label class="checkbox-ui">
              <input
                type="checkbox"
                [disabled]="disable"
                [checked]="row.permissions[col]"
                (change)="togglePermission(i, col)"
                class="disabled:bg-gray-500 disabled:cursor-pointer"
                />
              <span></span>
            </label>
          </td>

          <td>
            <label class="checkbox-ui">
              <input
                type="checkbox"
                [checked]="isAllChecked(row)"
                (change)="toggleAll(i)"
                [disabled]="disable"
              />
              <span></span>
            </label>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
